// Localised display names for AUTO-generated page names.
//
// Pages get a default name when created ("Seite 3", "Detail 1",
// "Positionsplan 2"). That string is DOCUMENT DATA — it is stored with the
// project and round-trips through .drawio exports. When the UI language is
// switched, such untouched default names should follow the language (a user
// who renamed a page to "Serverraum" keeps that name, of course).
//
// pageDisplayName() recognises the default patterns in either language and
// returns the localised form; any other (custom) name is returned unchanged.

const PATTERNS = [
  { re: /^(?:seite|page|sheet|blatt)\s+(\d+)$/i, de: 'Seite', en: 'Page' },
  { re: /^(?:detail|details|detailseite|detail page)\s+(\d+)$/i, de: 'Detail', en: 'Detail' },
  { re: /^(?:positionsplan|lageplan|location plan|location|floor plan)\s+(\d+)$/i, de: 'Positionsplan', en: 'Location plan' },
];

export function isAutoPageName(name) {
  const s = String(name == null ? '' : name).trim();
  return PATTERNS.some((p) => p.re.test(s));
}

export function pageDisplayName(name, lang = 'de') {
  const s = String(name == null ? '' : name).trim();
  for (const p of PATTERNS) {
    const m = p.re.exec(s);
    if (m) return `${lang === 'en' ? p.en : p.de} ${m[1]}`;
  }
  return s;
}

/** Default name for a NEW page of the given type (stored in the document). */
export function defaultPageName(type, n, lang = 'de') {
  if (type === 'detail') return `Detail ${n}`;
  if (type === 'location') return lang === 'en' ? `Location plan ${n}` : `Positionsplan ${n}`;
  return lang === 'en' ? `Page ${n}` : `Seite ${n}`;
}
